import React, { useContext, useEffect } from "react";
import Layout from "./Layout";

import GlobalContextProvider from "../../Contexts/GlobalContextProvider";
import AuthContextProvider, { AuthContext } from "../../Contexts/AuthContext";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";

function isTokenExpired(bearerToken) {
  if (!bearerToken || bearerToken === "No-Token-Present") return true;

  try {
    const rawToken = bearerToken.replace(/^Bearer\s+/i, "");
    const payloadBase64 = rawToken.split(".")[1];

    const payload = JSON.parse(
      decodeURIComponent(
        atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/"))
          .split("")
          .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
          .join(""),
      ),
    );

    if (!payload.exp) return false; // no exp claim, treat as non-expiring
    return payload.exp * 1000 < Date.now();
  } catch (e) {
    console.error("Failed to parse token:", e);
    return true; // if we can't parse it, treat as expired/invalid
  }
}

const Content = (props) => {
  const location = useLocation();

  const { logout } = useContext(AuthContext);

  useEffect(() => {
    if (props.publicRoute) return; // Skip token check for public routes

    const decryptedToken = CryptoJS.AES.decrypt(
      localStorage.getItem("token") || "No-Token-Present",
      process.env.REACT_APP_HASH_KEY,
    ).toString(CryptoJS.enc.Utf8);

    if (isTokenExpired(decryptedToken)) {
      logout();
    }
  }, [location.pathname, props.publicRoute]);

  return (
    <>
      <GlobalContextProvider>
        <Layout
          parentName={props.parentName}
          parentRoute={props.parentRoute}
          currentName={props.currentName}
          publicRoute={props.publicRoute}
          showHome={true}
          show={props.show}
        >
          {props.children}
        </Layout>
      </GlobalContextProvider>
    </>
  );
};

export default Content;
